import { ERROR_CODES } from '@trading/shared';

/**
 * Map a login API error to a localized i18n key under `login.errors.*`.
 *
 * The raw API `error.message` (e.g. "Invalid credentials") is English-only and
 * not meant for end users, so the UI maps the stable error CODE to a translated
 * message instead. AUTH_006 (email not verified) is handled separately by the
 * caller (it drives the resend-verification flow) and never reaches here.
 * Unknown codes fall back to the generic login-failed toast.
 */
export function parseLoginError(error: unknown): string {
  const code = (error as { response?: { data?: { error?: { code?: string } } } })
    ?.response?.data?.error?.code;

  switch (code) {
    case ERROR_CODES.INVALID_CREDENTIALS: // AUTH_001
      return 'login.errors.invalidCredentials';
    case ERROR_CODES.UNAUTHORIZED: // AUTH_004 — suspended account
      return 'login.errors.accountSuspended';
    case ERROR_CODES.RATE_LIMITED: // ERR_003 — too many attempts
      return 'login.errors.rateLimited';
    default:
      return 'login.toast.failed';
  }
}
